import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxntProgressBarComponent } from './rxnt-progress-bar.component';

@NgModule({
  declarations: [
    RxntProgressBarComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RxntProgressBarComponent,
  ],
})
export class RxntProgressBarModule {
}
